<template>
<div class="totalbox">
  <div class="listbox ">
    <div class="row rowdiv" v-if="getElementCount(prices.roomprice)>0" style="position:relative;">
      <p class="label " style="align-self: center;line-height: 2.5rem;;">
        Please complete the booking within the next
        <span class="fontBold">{{ permitMinutes }}</span>  minutes<img src="/images/flight/icon_tipinfo.png"
        class="ico" style="vertical-align: middle; " alt="" title=""
        @click="this.showTip=!this.showTip;"> to secure this price.
      </p>
      <div class="priceCheckBox">
        <div>Price check in </div>
        <div><span class="fontBold">{{ bookingCountdownMinutes }}</span> Mins : <span class="fontBold">{{ bookingCountdownSeconds }}</span> Secs</div>
      </div>
      <div v-if="showTip" @click="showTip = false" class="popTips_parent">
         <div class="popTips">
                <div class="block " style="padding:0px;margin:0">
                    <div class="r " style="padding:0px;margin:0">                       
                        <div class="left_c hand" style="padding:0px;margin:0;width: 100%;justify-content: flex-end;">
                            <img src="/images/icon_close.png"
                                style="width: 2.5rem; height: 2.5rem; object-fit: cover" />
                        </div>
                    </div>
                </div>
                Our airfare search will refresh after 20 minutes for the most updated pricing and availability.
              </div>
       </div>

    
    </div>

    <div class="row  " v-if="getElementCount(prices.roomprice)>0" style="position:relative;">
      <p class="label " style="align-self: center;">{{ prices.roomprice.title }}</p>
      <p class="contxt childcenter" :data-amount="prices.roomprice.price" data-type="tripprice" :data-name="prices.roomprice.title">{{ prices.roomprice.format }}
        <span @click="rmpriceCollaspe=(!rmpriceCollaspe)">
    <!--     <ArrowDownBold  class="arrow" v-if="rmpriceCollaspe"/>
        <ArrowUpBold class="arrow" v-else/> -->
      </span>
      </p>
    </div> 
    <template v-if="!rmpriceCollaspe">
      <div class="row " v-for="(item,idx) in prices.roompriceDetails" style="padding-left:50px;">
        <p class="label ">{{ item.title }}</p>
        <p class="contxt" :data-amount="item.price*item.qty" data-type="tripprice" :data-name="item.title">{{ priceFormat(odata.currency,item.price,',',2,1)+' X '+item.qty +' = '+priceFormat(odata.currency,item.price*item.qty,',',2,1) }}</p>
      </div>
    </template>
    <!-- <div class="listbox" style="position:absolute; z-index:999;background-color:#fff;
    border:1px solid #dcdcdc;border-radius: 5px;padding:5px 8px;">
         <div class="row" v-for="(item,idx) in prices.roompriceDetails">
             <div class="">{{ item.title }}</div>
             <div class="">{{ priceFormat(odata.currency,item.price,',',2,1)+' X '+item.qty +' = '+priceFormat(odata.currency,item.price*item.qty,',',2,1) }}</div>
         </div>
      </div> -->
    <template v-if="getElementCount(prices.options)>0">
      <div class="row" v-for="(item,idx) in prices.options">
        <p class="label">{{ item.title }}</p>
        <p class="contxt" :data-amount="item.price" data-type="option" :data-name="item.title">{{((item.price>=0)?'+':'')}} {{ item.format }}</p>
      </div>
    </template>
    <div class="row" v-if="getElementCount(prices.fly)>0">
      <p class="label">{{ prices.fly.title }}</p>
      <p class="contxt" :data-amount="prices.fly.price" data-type="flight" :data-name="prices.fly.title">+ {{ prices.fly.format }}</p>
    </div>
    <div class="row" v-if="getElementCount(prices.agentComm)>0">
      <p class="label">{{ prices.agentComm.title }}</p>
      <p class="contxt" :data-amount="prices.agentComm.price" data-type="agentCommission" :data-name="prices.agentComm.title"> {{ prices.agentComm.format }}</p>
    </div>
  </div>
  <div class="listbox" v-if="getElementCount(prices.discounts)>0">
    <div class="row" v-for="(item,idx) in prices.discounts">
      <p class="label">{{ item.title }}</p>
      <p class="contxt green" :data-amount="item.price" data-type="coupon_point" :data-name="item.title">{{ item.format }}</p>
    </div>
  </div>
  <div class="listbox">
    <div class="row total total-green" v-if="getElementCount(prices.totals)>0">
      <p class="label">{{ prices.totals.title }}</p>
      <p class="contxt" :data-amount="prices.totals.price" data-type="priceTotal" :data-name="prices.totals.title">{{ prices.totals.format }}</p>
    </div>
  </div>
</div>
<alertDialog
  v-if="showPriceChangedDialog"
  @closeWin="closePriceChangedDialog"
  title="Price Updated"
  content="The price for this trip has changed since you started booking. We'll take you back to review the updated price and details."
  :btnsetting="{ txt: 'Continue', bg: '#57855f', color: '#ffffff' }"
/>
<priceAlertDialog
  v-if="showApiPriceChangedDialog"
  :priceUpdate="updatedPriceInfo.flight"
  @closeWin="closePriceChangedDialog"
/>
</template>
<script>
import { notEmpty,priceFormat,priceAmount,slackMsg } from "@/utils/tool.js";
import Request from '@/services/Request.ts';
import { ArrowDownBold,ArrowUpBold } from '@element-plus/icons-vue'
import { useOrderStore } from "@/stores/OrderStore";
import { useInsuranceStore } from '@/stores/InsuranceStore';
import { useCurrencyStore } from '@/stores/CurrencyStore';
import { watch } from "vue";
import * as Sentry from "@sentry/vue";
import { localDriver } from '@/utils/localDriver'
import alertDialog from '@/components/alertdialog.vue'
import priceAlertDialog from '@/components/pricealertdialog.vue'
import { calcFlightOfferPrice } from '@/utils/flightPricing'

export default {
  components: {
    ArrowDownBold,
    ArrowUpBold,
    alertDialog,
    priceAlertDialog,
  },
  props:['step','refidx','rmkey','odkey'],
  emits:['oTotalRef','offerPriceUpdate','summaryPriceUpdate'],

	data() {
		return {  
      slackMsg,
      showTip:false,
      pressnum:2,
      ismobile:false, 
      isFilters:false,
      ischeck1:false,
      ischeck2:false,
      ischeck3:false,
      ischeck4:false,
      ischeck5:false,
      Baggage:['1Bag'],
      Preferred:['Basiceconomy'],
      Stops:['Nonstop'],
      Preferred:['Lufthansaairline'],
      Sort:['Price(lowest)'],
      peoplelist:[],
      showselTravBox: false,
      showaddTravBox: false,
      dataForm:{
          phonenum:'+86',
          amount:'full'
        },
      showHotelBox: false,
      people:[],
      prices:{},
      depinfo:{},
      odata:{},
      rmpriceCollaspe:false,
      insuranceTotal:0,
      opkey:'',
      prices_info:{},
      priceRecalcTimer: null,
      priceCalcRunning: false,
      priceCalcPending: false,
      bookingTimeTimer: null,
      permitMinutes:20,
      bookingCountdownMs: 20 * 60 * 1000, // 20 minutes in milliseconds
      showPriceChangedDialog: false,
      showApiPriceChangedDialog: false,
      apiPriceUpdateOriginal: '',
      apiPriceUpdateNewValue: '',
      apiPriceUpdateDiff: '',
      apiPriceUpdateIncreased: false,
      updatedPriceInfo:{trip:{},option:{},flight:{}},
      priceChanged:{trip:false,option:false,flight:-1},    //-1:no change or no flight, 0-tba flight changed,1-api flight changed
      forceCheckResolve: null,    // pending resolver for an on-demand check triggered via forcePriceCheck() (e.g. right before payment submit), separate from the periodic timer-driven check
      priceCheckInFlight: false,  // true while checkBookingPriceChange()'s webPost is in flight, whoever (timer or forcePriceCheck) triggered it
      currencyRound:0.3,
		}
	},
	computed: {
      // Watch insurance amount changes via computed property
      insuranceAmount() {
        return this.insuranceStore?.unPay || 0;
      },
      bookingCountdownMinutes() {
        const totalSeconds = Math.max(0, Math.ceil(this.bookingCountdownMs / 1000))
        const minutes = Math.floor(totalSeconds / 60)
        return String(minutes).padStart(2, '0')
      },
      bookingCountdownSeconds() {
        const totalSeconds = Math.max(0, Math.ceil(this.bookingCountdownMs / 1000))
        return String(totalSeconds % 60).padStart(2, '0')
      }
    },
	watch: {
      // Watch the computed insurance amount
      insuranceAmount:{
        async handler(newValue, oldValue) {
            //console.log('-------------price summary-----------------',this.odata)
            await this.pModelPriceCalc()
          },
          deep: true,
      },
      refidx:{
        async handler(newValue, oldValue) {
            await this.pModelPriceCalc()
          },
          deep: true
      },
      step:{
        async handler(newValue, oldValue) {
          // Recalculate when step changes (e.g., navigating to payment page)
          if(newValue >= 3) {
            // Use setTimeout to ensure insuranceStore is loaded
            setTimeout(async () => {
              await this.pModelPriceCalc()
            }, 100);
          }
        }
      }
  },
	async mounted() {
        if(document.documentElement.clientWidth<750){
            this.ismobile=true
        }else{
            this.ismobile=false
        }
        this.bookingCountdownMs = this.permitMinutes * 60 * 1000
        this.bookingtime()
        this.opkey = this.odkey.replace(/order_data/g,'orderPrices');
        await this.currencyStore.fetchCurrencies()
        if (typeof this.schedulePriceRecalc === 'function') this.schedulePriceRecalc(0)
        else this.pModelPriceCalc()
    },
    setup()
    {
      const  insuranceStore = useInsuranceStore()
      return {
        orderStore:useOrderStore(),
        insuranceStore,
        currencyStore:useCurrencyStore(),
      }
  },  
  beforeDestroy() {
    // 组件销毁钩子！SPA路由跳转(vue‑router)、v‑if销毁子组件都会触发
    // ✅组件销毁时刻，不管倒计时有没有跑完，强制清除属于本实例自己的定时器
    if (this.bookingTimeTimer) {
      clearInterval(this.bookingTimeTimer)
      this.bookingTimeTimer = null
    }
  },  
	methods: {
    async bookingtime(){
      let tk = this.orderStore.token
      let start = await localDriver.getItem('time_'+tk)
      let restTime = (start + this.permitMinutes * 60 * 1000) - new Date().getTime()   //start is new Date().getTime() at booking start; 20 minutes = 20 * 60 * 1000

      // 20 分钟下单时间，保持价格不变， 20后检查PHP端价格是否变动，需要timer倒计时
      this.bookingCountdownMs = Math.max(0, restTime)
      if (this.bookingTimeTimer) {
        clearInterval(this.bookingTimeTimer)
      }
      this.bookingTimeTimer = setInterval(() => {
        this.bookingCountdownMs -= 1000
        if (this.bookingCountdownMs <= 0) {
          clearInterval(this.bookingTimeTimer)
          this.bookingTimeTimer = null
          this.bookingCountdownMs = 0
          this.checkBookingPriceChange()
        }
      }, 1000)
    },
    async tripPriceChanged(newPrice,oldPrice){
      let res = false        
      if(notEmpty(newPrice)){
        for(let i = 1; i<7 ; i++){
           let currentPrice = parseFloat(newPrice['price'+i] || 0)
           let heldPrice = parseFloat(oldPrice['price'+i] || 0)
           if(Math.abs(currentPrice - heldPrice)>=this.currencyRound) {
                res = true
                break
           }
        }
      }
      if(res){
        this.odata = await localDriver.getItem(this.odkey)
        this.odata.prices_info[this.odata.depart_date] = newPrice     
        await localDriver.setItem(this.odkey,this.odata)
      }
      return res
    },
    async optionPriceChanged(newPrice,oldPrice){
      let res = false        
      if(notEmpty(newPrice) && notEmpty(oldPrice)){
        for(let i in newPrice){
          if(parseInt(newPrice[i].option_id) === 500){
            continue
          }
          let product_option_id = newPrice[i].product_option_id
          let old_product_option = oldPrice.find(op => op.product_option_id === product_option_id)
          if(!old_product_option ){
            // The server also returns options this booking never showed or saved (e.g. flight-upgrade options
            // for products booked without flights); they are not a price change for what the customer holds.
            continue
          }
          for(let j in newPrice[i].product_option_value){
            let product_option_value_id = newPrice[i].product_option_value[j].product_option_value_id
            let opvRaw = old_product_option.product_option_value
            let opvArr = Array.isArray(opvRaw) ? opvRaw : Object.values(opvRaw || {})
            let old_product_option_value = opvArr.find(opv => opv.product_option_value_id === product_option_value_id)
            if(!old_product_option_value){
              continue
            }
            else{
              let currentPrice = parseFloat(newPrice[i].product_option_value[j].price || 0)
              let heldPrice = parseFloat(old_product_option_value.price || 0)
              if(Math.abs(currentPrice - heldPrice) >=this.currencyRound){
                res = true
                break
              }
            }
          }
          if(res){
            break
          }
        }
      }
      if(res){     
        this.odata = await localDriver.getItem(this.odkey)      
        this.odata.oriOptions =  newPrice    
        await localDriver.setItem(this.odkey,this.odata)
      }
      return res
    },
    async apiPriceChanged(price){
      let res = -1 
      //todo: price?.beyondrange==1 need update flight price
      if((price?.beyondrange??0)>0){
         res = 1;
      }   
      return res
    },
    async tbaPriceChanged(newPrice,oldPrice){
      let res = -1 
      if(parseInt(oldPrice?.rid??1) === 0){
         if(Math.abs((parseFloat(newPrice?.total_price??newPrice?.base_price??0)- parseFloat(oldPrice?.info?.price?.total??0))) >= this.currencyRound ){
           res = 0
         }
         else if( Math.abs(parseFloat(newPrice?.deposit_amount??0)-parseFloat(oldPrice?.info?.deposit_amount?? 0)) >= this.currencyRound ){
            this.odata = await localDriver.getItem(this.odkey)
            this.odata.flightOffer.info.deposit_amount =  newPrice?.deposit_amount??0   
            this.odata.flightOffer.deposit =  parseFloat(newPrice?.deposit_amount??0) * (oldPrice?.persons??1)               
            await localDriver.setItem(this.odkey,this.odata) 
            res = 2
         }
      }
      return res
    },
    async checkBookingPriceChange() {
      if (this.priceCheckInFlight) return
      this.priceCheckInFlight = true
      let tk = this.orderStore.token
      this.odata = await localDriver.getItem(this.odkey)
      await localDriver.removeItem('reserve_'+tk)   //reserve : if return to details page, keep roomlist and  travelers info
      const flyType = (this.odata.flightOffer?.rid??-1)
      // stops: the offer is priced base + stop surcharge + baggage fare, so the check needs its stop option
      const currentflight = (flyType >= 0)?{id:this.odata.flightOffer.id,rid:this.odata.flightOffer.rid,stops:this.odata.flightOffer.selectedStops??this.odata.flightOffer.info?.stops}:{}
      
      new Request().webPost(
        {
          product_id:this.odata.product_id,
          depart_date:this.odata.depart_date,
          pageCurrency:this.currencyStore.currentCurrency,
          //tbaid:(this.odata.flightOffer?.rid??1)>0?0:(this.odata.flightOffer?.id??0),
          flight:currentflight,
        },
        async (res)=>{
          this.priceCheckInFlight = false
          this.updatedPriceInfo.trip = res.data?.trip??{};
          this.updatedPriceInfo.option = res.data?.option??{};
          this.updatedPriceInfo.flight = res.data?.flight??{};
          if(this.updatedPriceInfo.flight.tba??false){
            this.updatedPriceInfo.flight.tba.offer = this.odata.flightOffer
          }
          const apiPrice = res.data?.flight?.api??{};

          this.priceChanged = {
            trip:await this.tripPriceChanged(this.updatedPriceInfo.trip,this.odata.prices_info[this.odata.depart_date] || {}),
            option:await this.optionPriceChanged(this.updatedPriceInfo.option,this.odata.oriOptions || {}),
            flight:notEmpty(apiPrice)?await this.apiPriceChanged(apiPrice):
                        await this.tbaPriceChanged(res.data?.flight?.tba??{},this.odata.flightOffer??{})
          }
          if(this.priceChanged.flight >= 0){ 
             this.$emit('offerPriceUpdate',{              
                  responseOfferId:this.odata.flightOffer.rid,
                  offerId:this.odata.flightOffer.id,
                  offer:apiPrice.current??{}}
                );    
             this.showApiPriceChangedDialog = true
          }
          else if  ( this.priceChanged.trip || this.priceChanged.option) {
            this.showPriceChangedDialog = true
          }
          else{
            // Price has not changed, reset the timer for another 20 minutes
            this.timerReset();
            this.resolveForceCheck(true)
          }
        },
        'product/product/getProductPrice',
        (err)=>{
          this.priceCheckInFlight = false
          // The request failed rather than confirming the price is fine, but forcePriceCheck()
          // (or the timer, if this fired on its own) already stopped the countdown to run this
          // check - if we don't restart it here, it stays stopped indefinitely.
          this.timerReset()
          this.resolveForceCheck(true)
        }
      );
    },
    async resolveForceCheck(ok){
      if(!ok){
        // Any false resolution means the user is being redirected away (declined, or a
        // trip/option price changed) - reset the shared timestamp before the page unloads
        // so the destination page's own countdown starts fresh instead of inheriting a
        // near-expired one.
        await this.timerReset()
        if (!this.bookingTimeTimer) {
            this.bookingtime()
        }
      }
      if(this.forceCheckResolve){
        const resolve = this.forceCheckResolve
        this.forceCheckResolve = null
        resolve(ok)
      }
    },
    async forcePriceCheck(){
      return new Promise((resolve)=>{
        if (this.priceCheckInFlight || this.showPriceChangedDialog || this.showApiPriceChangedDialog) {
          this.forceCheckResolve = resolve
          return
        }
        if (this.bookingTimeTimer) {
          clearInterval(this.bookingTimeTimer)
          this.bookingTimeTimer = null
        }
        this.forceCheckResolve = resolve
        this.checkBookingPriceChange()
      })
    },
    async flightOfferRest(){
        this.odata = await localDriver.getItem(this.odkey) 
        let persons = this.odata.flightOffer?.persons??1
        let tripFlightInfo = this.odata.tripFlightInfo??{}
        let newflytotal = 0
        let istba = (this.updatedPriceInfo.flight?.api?.previous??false)===false

        if(istba){
          // total_price is per person and already holds everything the offer is priced at (base price, stop
          // surcharge, baggage) in the page currency. Re-price it like the offer list does (flight/filter.vue
          // getFlightPrice: per-person total minus the product's city price) so Ticket Price, which shows
          // (cityprice + price) x persons, stays right for any number of travelers.
          const perPerson = parseFloat(this.updatedPriceInfo.flight?.tba?.total_price??this.updatedPriceInfo.flight?.tba?.base_price??0)
          newflytotal = perPerson*persons
          let calPrice = calcFlightOfferPrice({
                        totalPrice: perPerson,
                        persons,
                        vendor: 'tba',
                        tripFlightInfo,
                        cityPrice:this.odata.cityprice
                  });
          if(perPerson>0){
                this.odata.flightOffer.price = parseFloat(calPrice)
                this.odata.flightOffer.api_price = parseFloat(calPrice) + (parseFloat(this.odata.cityprice) || 0)
                this.odata.flightOffer.info.finalprice = calPrice
                this.odata.flightOffer.info.price.total = perPerson
                //this.odata.flightOffer.info.deposit_amount =  this.updatedPriceInfo.flight.tba.deposit_amount
                await localDriver.setItem(this.odkey,this.odata) 
           }
        }
        else{
           newflytotal = this.updatedPriceInfo.flight?.api?.current?.price?.total??0
           if(newflytotal>0){
                this.odata.flightOffer.price = calcFlightOfferPrice({
                        totalPrice: newflytotal,
                        persons,
                        vendor: this.updatedPriceInfo.flight?.api?.vendor??'amadeus',
                        tripFlightInfo,
                        cityPrice:this.odata.cityprice
                  });
                this.odata.flightOffer.api_price = newflytotal /persons  
                await localDriver.setItem(this.odkey,this.odata) 
           }
        }
        
    },
    async apiFlightReset(){
      this.odata = await localDriver.getItem(this.odkey)
      delete this.odata.flightOffer
      delete this.odata.flightSummary
      delete this.odata.flights_amount
      delete this.odata.hasoffer
      await localDriver.setItem(this.odkey,this.odata) 
      this.timerReset()
    },
    async timerReset(){
      let tk = this.orderStore.token
      await localDriver.setItem('time_'+tk,new Date().getTime())
      this.bookingCountdownMs = this.permitMinutes * 60 * 1000
      this.bookingtime()
    },
    async closePriceChangedDialog(parm){
      let page = ''
      let tk = this.orderStore.token  
      this.showPriceChangedDialog = false
      this.showApiPriceChangedDialog = false
  
      if(this.priceChanged.flight >= 0 ){
        if(this.priceChanged.flight == 2 && this.step > 3){
            //tba deposit -- only payment page reload
            await this.pModelPriceCalc()
            page = '/payment?tk=' + tk
        }               
        else if((parm?.confirm??false) === true){
            await localDriver.setItem('clearCache',1)
             //1.更新Flight offer (fdata )；
            //2.按Flight 的price方法(flight fliter page : async getFlightPrice(fitm))，重算这个offer的价格，
            //3.更新 odata.flightoffer(flight page : async refreshSumary(param) )
            //4.更新 odata.flightSummary(flight page : async refreshSumary(param) )  
            await this.flightOfferRest()              
            this.timerReset()
            await this.pModelPriceCalc() 
            if(this.step >= 3){              
              page = '/booking/insurance?tk=' + tk
            }
            else {
              this.$emit('summaryPriceUpdate')   
            }        
        }
        else{
          // 2.另选机票，跳转：Flight page
          //php 端机票缓存清除,重新获取机票
          await localDriver.setItem('clearCache',1) 
          await this.apiFlightReset()
          page = '/flight?tk=' + tk
        }
      }
      else{
        await this.pModelPriceCalc() 
        if(this.step >= 2 ){
          if(this.priceChanged.option){
            page = '/booking?tk=' + tk
          }
          else if(this.step >= 3){    //trip price changed 
            page = '/booking/insurance?tk=' + tk
          }
        }      
      } 
      if(page!=''){
        await this.resolveForceCheck(false)
        window.location.href = page
        return
      }
      this.resolveForceCheck(true)
    },
    priceFormat(cur,total,s,d,p=0){
      return priceFormat(cur,total,s,d,p);
    } ,
    getElementCount(variable){
      let cnt = 0; 
      if (Array.isArray(variable)) {
        cnt = variable.length;
      } else if (typeof variable === 'object' && variable !== null) {
        cnt = Object.keys(variable).length;
      } 
      return cnt ;
    },
    async init_prices_info(){
      this.odata = await localDriver.getItem(this.odkey)
      const currentflight = (this.isFlight>0 && (this.odata.flightOffer?.id??0)>0)?{id:this.odata.flightOffer.id,rid:this.odata.flightOffer.rid}:{}
      new Request().webPost(
        {product_id:this.odata.product_id,depart_date:this.odata.depart_date,flight:currentflight},
        async (res)=>{
          //console.log('----get_prices_info---',res);        
          this.odata.prices_info[this.odata.depart_date] = res.data
          await localDriver.setItem(this.odkey,this.odata)
          await this.pModelPriceCalc()
        },
        'product/product_trip/get_prices_info',
      );      
    },
    async pModelPriceCalc()
    {
      this.odata = await localDriver.getItem(this.odkey);
      if (this.priceCalcRunning) {
        this.priceCalcPending = true
        return
      }
      this.priceCalcRunning = true
      try {     
      if (!this.odata) {
        this.$router.replace('/')
        return
      }
      if(('priceModel' in this.odata) && notEmpty(this.odata.priceModel))
      {
         await this.priceCalc();
      }
      else{               
        if(!notEmpty(this.odata.product_id) || this.odata.product_id<1)
        {
          try{
            throw new Error("Product ID is not found, Error 04: "+JSON.stringify(this.odata) );
          }
          catch(e)
          {
            Sentry.captureException(e);
          }
        }
        else{
          new Request().webPost(
            {
              product_id: this.odata.product_id,
            },
            async (res) => {
              let priceModel = res.data
              if(!Array.isArray(priceModel) || priceModel.length === 0)
              {
                 slackMsg(new Request(),"Price Model is not found ("+this.odata.product_id+','+this.odata.depart_date+")");
              }
              else{
                  let pModel = [];
                  let roomlist = await localDriver.getItem(this.rmkey)
                  if (priceModel && roomlist) 
                  {
                    for (let r in roomlist) {
                      let roomItem = roomlist[r];
                      for (var i in priceModel) {
                        let pm = priceModel[i];                    
                        if (roomItem.Adults == pm.adult && roomItem.Child == pm.child && pm.child_nopax == 0 && pm.infant == 0 && pm.infant_nopax == 0) {
                          pModel.push(pm);                      
                          break;
                        }
                      }
                    }
                  }
                  if(pModel)
                  {
                    this.odata = { ...this.odata, priceModel: pModel }         
                    await localDriver.setItem(this.odkey, this.odata)
                    await this.priceCalc()
                  }
              }          
            },
            'product/product/getProductPriceModule'
          )
        }
      }      
      } finally {
        this.priceCalcRunning = false
        if (this.priceCalcPending) {
          this.priceCalcPending = false
          await this.pModelPriceCalc()
        }
      }
    },
    async priceCalc()
    {
        //console.log('--------------------------->>>>>>>>>>>>>>>>>>>>>>>>>>>>>>');
        let sum = 0;
        this.insuranceTotal = 0;
        this.odata = await localDriver.getItem(this.odkey) 
        let roomlist = await localDriver.getItem(this.rmkey)
        try{
          if(notEmpty(this.odata) && notEmpty(this.odata.product_info) && notEmpty(this.odata.product_info.model))
          { 
            let fpTrip = (this.odata.product_info.model.toUpperCase().slice(0,3)==='FP-');
            // FP package base airfare per pax:
            // 1) tripFlightInfo.baseprice (authoritative when flight options are available)
            // 2) cityprice
            // 3) TBAprice
            // This keeps Package Price stable after selecting a specific offer.
            const fpAddonPerPax = fpTrip
              ? (
                  parseFloat(this.odata?.tripFlightInfo?.baseprice ?? 0) ||
                  parseFloat(this.odata?.cityprice ?? 0) ||
                  parseFloat(this.odata?.TBAprice ?? 0) ||
                  0
                )
              : 0
            //todo: trip price
            let tripPrice = 0 ;
            let tripPriceDetails = [];
            this.prices = {};
            for(let r in roomlist)
            {
              let item = roomlist[r];
              let rmpList = this.rmPrice(item, this.odata, fpAddonPerPax);
              let curroomprice = parseFloat(rmpList.totalPrice);
              tripPrice += curroomprice;
              if(rmpList.details)
              {            
                if(tripPriceDetails.length<1)
                {
                    tripPriceDetails = rmpList.details;
                }
                else
                {
                    for(let j in rmpList.details)
                    {
                        let noExist = true;
                        for(let k in tripPriceDetails)
                        {
                          if(rmpList.details[j].title == tripPriceDetails[k].title && rmpList.details[j].price == tripPriceDetails[k].price)
                          {
                            noExist = false;
                            tripPriceDetails[k].qty += rmpList.details[j].qty;
                            break;
                          }
                        }
                        if(noExist)
                        {
                          tripPriceDetails.push(rmpList.details[j]);
                        }                    
                    }
                }
              }          
            }

            //if(tripPrice>0)
            { 
              //console.log('-------------------odata-----------',[this.odata,tripPriceDetails]);
              let isPFtrip = this.odata.product_info.model.toUpperCase().slice(0,3)==='FP-';
              sum += tripPrice ;
              this.prices = {...this.prices,
                roomprice:{title:(isPFtrip)?'Package Price':'Tour Price',price:tripPrice,format:priceFormat(this.odata.currency,tripPrice,',',2,1)},
                roompriceDetails:tripPriceDetails,
              }
            }
            //todo: flight price;
            let flyamt = 0;
            delete this.prices.fly;
            let flights_amount = 0;
            if(('flightOffer' in this.odata) && (this.odata.flightOffer.id > 0) && this.odata.isFlight > 0)
            {
                flyamt = parseFloat(this.odata.flightOffer.price) * parseInt(this.odata.flightOffer.persons);
                if(fpTrip)
                {
                    if(flyamt > 0)
                    {
                      this.prices = {...this.prices,fly:{title:'Flight Surcharge',price:flyamt,format:priceFormat(this.odata.currency,flyamt,',',2,1)}}; 
                      sum += flyamt;
                    }
                    flyamt+=parseFloat(this.odata.cityprice)* parseInt(this.odata.flightOffer.persons);
                    flights_amount = flyamt;            
                }
                else{
                    flights_amount = flyamt + parseFloat(this.odata.cityprice) * parseInt(this.odata.flightOffer.persons);            
                }            
            }    
            this.odata = {...this.odata,flights_amount:flights_amount};   
            await localDriver.setItem(this.odkey,this.odata) 
            //todo: option price;
            if( this.step >= 2 )
            {
                //console.log('----------------has option price---------------',660);
                //todo: get all seleted option total
              
                let optlist = this.getOptions(this.odata);
                sum += optlist.sum;
                this.prices = {...this.prices,options:optlist.options}; 

                //console.log('--------------end options---------------',this.prices);
                //todo: discout price;
                if(this.step >= 3)
                {
                    //todo: 如果有保险功能
                    this.insuranceTotal = this.insuranceStore?.unPayDisplay ?? this.insuranceStore?.unPay ?? 0;
                    if(this.insuranceTotal>0)
                    {
                      let insurance = {title:'Travel Protection Price',price:this.insuranceTotal,format:priceFormat(this.odata.currency,this.insuranceTotal,',',2,1)};
                      // Insurance will be added to final total in bookingPaymentSummary, not here
                      // Do not add to sum to avoid double-counting
                      // sum += parseFloat(this.insuranceTotal);
                      this.prices = {...this.prices,insurance:insurance};
                    }
                    if(this.step >= 4)
                    {
                      if(notEmpty(this.odata.agentComm) && this.odata.agentComm > 0)
                      {
                          let agentComm = {title:'Commission',price:this.odata.agentComm,format:priceFormat(this.odata.currency,-parseFloat(this.odata.agentComm),',',2,1)};                    
                          sum -= parseFloat(this.odata.agentComm);
                          this.prices = {...this.prices,agentComm:agentComm};
                      }
                    }
                    if(this.step >= 11114)
                    {  

                      let discounts = [];
                      let discountprice = 0;
                      for(let i in this.odata.totals)
                      {
                          if(this.odata.totals[i].code.includes('coupon'))
                          {
                                discountprice = priceAmount(this.odata.totals[i].text);
                                sum += discountprice;
                                discounts.push({title:this.odata.totals[i].title,price:discountprice,format:priceFormat(this.odata.currency,discountprice,',',2,1)});
                          }
                          else if('credit'==this.odata.totals[i].code.toLowerCase() )
                            {
                                discountprice = priceAmount(this.odata.totals[i].text);
                                sum += discountprice;
                                discounts.push({title:'Points',price:discountprice,format:priceFormat(this.odata.currency,discountprice,',',2,1)});
                            }
                        }
                        this.prices = {...this.prices,discounts:discounts};
                    }                
                }
            } 
            this.prices = {...this.prices,totals:{title:((fpTrip)?'Package':'Tour')+' Total Price',price:sum,format:priceFormat(this.odata.currency,sum,',',2,1)}};
            //console.log('----finalsummary---',this.prices);
            this.orderStore.setOrderPrices(this.opkey,this.prices)
            this.$emit('oTotalRef',{priceSummary:this.prices});
          }
          else{
            this.$router.replace('/');
          }
        }catch(e){
          
        }
    },
    getOptions(odata)
    {
        let options = [];
        let sum = 0;
        for(let i in odata.oriOptions)
        {
            let opvTotal = 0;
            for(let j in odata.oriOptions[i].product_option_value)
            {
                let povlist = odata.oriOptions[i].product_option_value[j];
                let povprice = parseFloat(povlist.price_prefix+povlist.price);
                if((povprice!=0) && ('options' in odata) && ((''+povlist.product_option_value_id) in odata.options))
                {
                   let persons = this.getElementCount(odata.options[povlist.product_option_value_id]);
                   if(persons > 0)
                   {
                      let optp = povprice*persons;
                      sum += optp;
                      opvTotal+=optp;
                   }
                }
            }
            if(opvTotal!=0)
            {
               options.push({
                   title:odata.oriOptions[i].name,
                   price:opvTotal,
                   format:priceFormat(odata.currency,opvTotal,',',2,1),
               });
            }
        }              
        return {sum:sum,options:options};
     },
    rmPrice(roomItem,odata,fpAddonPerPax=0) {
        let totalPrice = 0; 
        let details = [];       //[{price:,qty:,}....]
        let prices_info = odata.prices_info;
        let pModel = odata.priceModel;
       
        try 
        {
            if(pModel)
            {
              let dateprice = prices_info[odata.depart_date] || {};
              let pricemodel = {};
              for(var i in pModel)
              {
                let pm = pModel[i];          
                if(roomItem.Adults == pm.adult && roomItem.Child == pm.child && pm.child_nopax==0 && pm.infant==0 && pm.infant_nopax==0)
                {
                    pricemodel = pModel[i];
                }
              }
              if(notEmpty(dateprice)  && notEmpty(pricemodel))
              {
                //console.log('-----pricemodel-----',pricemodel)
                for(var i=1; i<7; i++ )
                {
                  let qty = parseInt(pricemodel['ceof'+i]);
                  let curp = parseFloat(dateprice['price'+i]);
                  let title = 'Trip';

                /// console.log('----i=2-----00-----------',[i,qty,curp])
                  if((qty>0) && (curp!=0))
                  {
                    if(pricemodel.trip_type==4 && i==5)
                    {
                      title = 'Solo Occupancy';
                    }
                    else{
                      curp += fpAddonPerPax;
                    }
                    totalPrice +=  curp * qty;
                    let noExist = true;
                    for(let j in details)
                    {
                        if(details[j].title == title && details[j].price==curp)
                        {
                            noExist = false;
                            details[j].qty+=qty;
                            break;
                        }
                    }
                    if(noExist)
                    {
                      details.push({title:title,price:curp,qty:qty});
                    }              
                  }
                }
              }
            }
            else{
              throw new Error("Price Model is Null : ("+odata.product_id+','+odata.depart_date+")");
            }
        } catch (e) {
          Sentry.captureException(e);
            //console.log("Caught an exception: " + e.message);
        }
				return {totalPrice:totalPrice,details:details};
			},  
  },
};
</script> 

<style scoped>   



.totalbox{
    padding: 0 2.4rem ;
    border-radius: 1.2rem;
    margin-bottom: 2.4rem;
    background: #fff;
}
.totalbox .titbox{
    padding-top: 2rem;
    color: #333;
    font-family: Poppins-Bold;
    font-size: 1.6rem;
    font-weight: 700;
    line-height: 2.2rem;
}
.totalbox .infobox{
    padding: 1.6rem 0 2.4rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #EAEAEA
}
.totalbox .infobox .pic{
    width: 8rem;
    height: 7rem;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    border-radius: 0.8rem;
}
.totalbox .infobox .txt{
    width: calc(100% - 9.2rem);
    font-family: Poppins;
    font-size: 1.4rem;
    font-weight: 500;
    line-height: 2.0rem;
    text-align: left;
}
.totalbox .listbox{
    padding: 1.2rem 0;
    border-bottom: 1px solid #EAEAEA
}
.totalbox .listbox:last-child{
    border-bottom: 0;
}
.totalbox .listbox .tit{
    font-family: Poppins-Bold;
font-size: 1.4rem;
font-weight: 700;
line-height: 2rem; 
padding: 0.8rem 0;
}
.totalbox .listbox .row{
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    font-family: Poppins;
    font-size: 1.4rem;
    font-weight: 500; 
    line-height: 2rem;
    padding: 0.8rem 0;
}
.totalbox .listbox .row .arrow{
  width:15px;
  margin-left:5px;
}
.totalbox .listbox .row.total{
    font-size: 1.6rem; 
    font-family: Poppins-Bold;
    font-weight: 700;
}
.totalbox .listbox .row .label{
    color: #666666;
}
.totalbox .listbox .row .airico{
    width: 2rem;
    display: block;
}
.totalbox .listbox .rowdiv{
   line-height: 1rem;
   flex-direction: column;
   align-items: flex-start;
}
.totalbox .listbox .rowdiv .fontBold{
  font-weight: bolder;
}
.totalbox .listbox .rowdiv .ico{
   cursor: pointer;
    width: 2rem;
    display: inline-block;
    position:relative;
    margin-bottom: -0.5rem;
    top:-0.4rem;
}
.totalbox .listbox .rowdiv .priceCheckBox{
    display: flex;
    align-self: center;
    width: -moz-fit-content;
    width: fit-content;
    margin: 0.8rem 0;
    padding: 0.8rem 1.6rem;
    border: 1px solid #4F6F52;
    border-radius: 10px;
    color: #4F6F52;
    font-size: 1.6rem;
    white-space: nowrap;
}
.totalbox .listbox .rowdiv .priceCheckBox .fontBold{
    margin: 0 0.3rem;
}
.totalbox .listbox .row.total .label,
.totalbox .listbox .row .label span.black,
.totalbox .listbox .row .contxt{
    color: #333333;
}
.totalbox .listbox .row.total.total-green .label,
.totalbox .listbox .row.total.total-green .contxt{
    color: #4F6F52 !important;
}
.totalbox .listbox .row .green{
    color: #4F6F52!important;
    white-space: nowrap;
}
/* 移动端  */
@media screen and (max-width:750px) {   
    
}
</style> 
